import React from "react";
import { Link, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Layout from "../components/layout";
import Nav from "../components/nav";
import Seo from "../components/seo";
import * as styles from "./wall-paintings.module.css";

const WallPaintingsPage = ({
  data: {
    allMdx: { nodes: paintings },
  },
}) => (
  <Layout>
    <Seo title="Wall Paintings" />
    <Nav />
    <section className={styles.main}>
      {paintings.map((painting) => (
        <Link key={painting.id} to={painting.slug}>
          <GatsbyImage
            className={styles.preview}
            imgClassName={styles.previewImage}
            image={getImage(painting.frontmatter.main_image)}
            alt={`${painting.title} preview image`}
            objectFit="contain"
            placeholder="none"
          />
        </Link>
      ))}
      <p className={styles.wallPaintingContact}>
        <span>For custom wall-painting quotes please email </span>
        <a href="mailto:liz@repeatingpattern.com">liz@repeatingpattern.com</a>
      </p>
    </section>
  </Layout>
);

export default WallPaintingsPage;

export const wallPaintingsQuery = graphql`
  query WallPaintingsIndexQuery {
    allMdx(
      filter: { fields: { collection: { eq: "wallPaintings" } } }
      sort: { fields: frontmatter___position, order: DESC }
    ) {
      nodes {
        id
        slug
        frontmatter {
          position
          title
          main_image {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  }
`;
